import type { FaireProductEntity } from "../../entity_types/product";

export const p_d66z8mr5ml: FaireProductEntity = {
  token: "p_d66z8mr5ml",
  type: "product",
  name: "Moroccan Blankets",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/e72d66fab9621b173356305a2fc4215c2a719ffa1dd94ab4822519b2f42d7cf3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7bf83359f258636741d88cb8e50ee980a852995fa1ba55afb7d28e7266196935.jpeg",
    "https://cdn.faire.com/fastly/a0de893b64ceeedddb063b9f94dadaeda7f03f6ea1556242da5ca6e4f211c907.jpeg",
    "https://cdn.faire.com/fastly/3f47daaf7b577fee37ac7a80505639eeb7a1fefc8a1c43e7631a531a4ab8b283.jpeg",
    "https://cdn.faire.com/fastly/10065410ee243d662d3f04917928237b83ff3902e29b418d0c044fe9b2d0fbfc.jpeg",
    "https://cdn.faire.com/fastly/cb64cb09e80895b402b168db483f780a85deb46450d83d2118183c5454115eac.jpeg",
  ],
  priceDollars: 50,
  description:
    "Handwoven textiles are woven on home looms and given as gifts to mark special occasions and milestones.\n\nLike a long friendship, the natural cotton in our Moroccan blankets arrives with a bit of coarseness to them, but the fibers relax as the blankets are lived in and loved in.\n\nDry clean only. Size: 78'' x 58''\n\n",
  tags: [],
  msrpDollars: 100,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:59.137Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
